import Vue from 'vue';
import VueRouter from 'vue-router';

import IndexFour from '../pages/indices/IndexFour.vue';
import Eula from '../pages/terms/Eula.vue';
import Contact from '../pages/terms/Privacy.vue';



Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: IndexFour,
    meta: { title: 'InquestPro - Test management simplified' }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Contact,
    meta: { title: 'InquestPro - Test management simplified' }
  },
  {
    path: '/eula',
    name: 'Eula',
    component: Eula,
    meta: { title: 'InquestPro - Test management simplified' }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const element = document.getElementById(to.meta.anchor);
      if (element) {
        
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        });
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title)
    document.title = to.meta.title;
  next();
});


export default router
